/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Trigger/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Trigger({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/PatientOptions/Existing/Content/AppointmentSelect/Content/Content/AppointmentSelect/Content/Trigger"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let selectedTypeColorValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'type_color',
format: fromFormat.appointmentTypeColor,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let selectedTypeNameValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'type_name',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 type="secondary"
>
{childProps => (
<div
  data-testid="Trigger.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-HFmAS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Trigger.Vertical"
  data-view-path={viewPath}
 style={{'--bc-2-HFmAS': selectedTypeColorValueData,'--h-3-HFmAS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--w-4-HFmAS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="selected.type_name"
 text={selectedTypeNameValueData}
 weight="medium"
 size="small"
/>
</div>
)}
</TysiaButton>
{children}
</React.Fragment>)
}